import { Alert, Box, Typography } from '@mui/material'
import type { ReactNode } from 'react'
import { Title, useTranslate } from 'react-admin'
import { useTwoFactor } from './twoFactor'
import { TwoFactorSetup } from './TwoFactorSetup'

/**
 * When app_settings makes two-factor sign-in mandatory for admins, an admin
 * without it gets the setup instead of the CMS, until it is done. This is the
 * nudge; the protection is nhost/auth's, which from then on refuses a session
 * without the code.
 */
export const TwoFactorGate = ({ children }: { children: ReactNode }) => {
  const translate = useTranslate()
  const mfa = useTwoFactor()
  if (!mfa.loaded || !mfa.required || !mfa.isAdmin || mfa.active) return <>{children}</>
  return (
    <Box sx={{ p: 2, maxWidth: 820 }} data-testid='mfa-gate'>
      <Title title={translate('account.mfa.required_title')} />
      <Typography variant='h6' sx={{ mb: 1 }}>
        {translate('account.mfa.required_title')}
      </Typography>
      <Alert severity='warning' sx={{ mb: 2 }}>
        {translate('account.mfa.required')}
      </Alert>
      <Typography variant='body2' color='text.secondary' sx={{ mb: 2 }}>
        {translate('account.mfa.intro')}
      </Typography>
      <TwoFactorSetup onDone={() => mfa.refetch()} />
    </Box>
  )
}

export default TwoFactorGate
